/* eslint-disable no-console */
import Script from 'next/script';

function createScript(script, toggles) {
	if (!script.toggle || (script.toggle && toggles[script.toggle])) {
		const scriptData = {};
		scriptData.key = script.id;
		scriptData.id = script.id;
		scriptData.strategy = script.strategy;

		if (script.src) {
			scriptData.src = script.src;
		}
		if (script.inline) {
			scriptData.dangerouslySetInnerHTML = { __html: script.inline };
		}

		script.dataAttributes?.forEach((att) => {
			scriptData[`data-${att.key}`] = att.value;
		});

		return <Script {...scriptData}></Script>;
	}

	return false;
}

export { createScript };
